import { useCallback, useEffect, useState } from 'react';
import { ENUM_LOCALE_CODE } from 'global.enums';
import { DocumentDirection } from 'global.interfaces';

export const useDocumentDirection = (defaultLanguage: ENUM_LOCALE_CODE) => {
  const [documentDirection, setDocumentDirection] = useState<DocumentDirection>('ltr');

  const htmlDocumentHandler = useCallback((locale: ENUM_LOCALE_CODE) => {
    const newDocumentDirection: DocumentDirection = locale === 'ar' ? 'rtl' : 'ltr';

    const languageCode = locale.split('-')[0];

    setDocumentDirection(newDocumentDirection);
    document.documentElement.dir = newDocumentDirection;
    document.documentElement.lang = languageCode;
  }, []);

  useEffect(() => {
    htmlDocumentHandler(defaultLanguage);
  }, [defaultLanguage, htmlDocumentHandler]);

  return documentDirection;
};
